import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { IconButton } from '../../atomicComponents';
import { InfoIcon } from '../../icons';
import VcPendingMasterDataInfo from '../VcPendingMasterDataInfo/VcPendingMasterDataInfo';
import styles from './VcWithPartialDataInfo.module.css';
import { JLR_PLANT, APPLICATION_VARIANTS } from '../../constants';
import config from '../../config/config';
import { usePlantAndLinesStore } from '../../providers/PlantAndLinesStore/PlantAndLinesStore';

const VcWithPartialDataInfo = ({ vcData: { vc, partialData }, lineName }) => {
  const iconRef = useRef(null);
  const [isVcInfoPopupOpen, setIsVcInfoPopupOpen] = useState(false);
  const [plant] = usePlantAndLinesStore().plantState;

  const openPopup = () => setIsVcInfoPopupOpen(true);
  const closePopup = () => setIsVcInfoPopupOpen(false);

  const { APPLICATION_VARIANT } = config;
  const hasMissingAggregatesData = data => !data.hasAllAggregates;

  const hasMissingVcMasterDataConfirmed=data=>
  APPLICATION_VARIANT === APPLICATION_VARIANTS.MES4_EV?
  !data.isVcMasterDataConfirmed:null;
  

  const hasMissingSMHData = data =>
    data.lineAttributes
      .filter(line => line.lineName === lineName)
      .map(line => line.smh)
      .some(smh => !smh);

  const hasMissingBasicInfo = data =>
    APPLICATION_VARIANT === APPLICATION_VARIANTS.MES4_EV
      ? !data.vcAlias || !data.vcFamily 
      : !data.vcAlias || !data.vcFamily || !data.vcOrderFrequency;


  const hasNoCostRelease = data => !data.isCostReleased;

  const hasPartialData =
    partialData &&
    (hasMissingBasicInfo(partialData) ||
      hasMissingSMHData(partialData) ||
    (APPLICATION_VARIANT === APPLICATION_VARIANTS.MES4_EV&&hasMissingVcMasterDataConfirmed(partialData))||
      (plant.label !== JLR_PLANT && hasMissingAggregatesData(partialData)) ||
      hasNoCostRelease(partialData));

  return (
    <>
      <div className={styles.container}>
        <div className={styles.infoIconContainer}>
          {hasPartialData && (
            <IconButton
              ref={iconRef}
              onClick={openPopup}
              className={styles.iconButton}
              aria-label={`show-missing-info-for-vc-${vc}`}
            >
              <InfoIcon className={styles.icon} />
            </IconButton>
          )}
        </div>
        <div className={styles.vc}>{vc}</div>
      </div>
      {hasPartialData && (
        <VcPendingMasterDataInfo
          vc={vc}
          isBasicInfoPending={hasMissingBasicInfo(partialData)}
          isCostReleasePending={hasNoCostRelease(partialData)}
          isVCAggregateBomPending={hasMissingAggregatesData(partialData)}
          isSMHPending={hasMissingSMHData(partialData)}
          isVcMasterDataConfirmed={hasMissingVcMasterDataConfirmed(partialData)}
          open={isVcInfoPopupOpen}
          handleClose={closePopup}
          anchorEl={iconRef.current}
        />
      )}
    </>
  );
};

VcWithPartialDataInfo.propTypes = {
  lineName: PropTypes.string.isRequired,
  vcData: PropTypes.shape({
    vc: PropTypes.string.isRequired,
    partialData: PropTypes.shape({
      isCostReleased: PropTypes.bool,
      hasAllAggregates: PropTypes.bool,
      lineAttributes: PropTypes.arrayOf(
        PropTypes.shape({
          lineName: PropTypes.string,
          smh: PropTypes.number,
        }),
      ),
      vcAlias: PropTypes.string,
      vcFamily: PropTypes.string,
      vcOrderFrequency: PropTypes.string,
    }),
  }).isRequired,
};

export default VcWithPartialDataInfo;
